module.exports = __webpack_public_path__ + "img/festival_zvirecich_piv.3ff51f40.png";